if (!customElements.get('product-description')) {
  customElements.define('product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description__content');
      this.button = this.querySelector('.product-description__toggle');
      if (!this.content || !this.button) return;

      this.expanded = false;
      this.onToggle = () => {
        const collapsing = this.expanded;
        this.expanded = !this.expanded;
        this.update();

        // After expansion, take the reader to the first newly revealed content
        // instead of following the button as it moves to the end of the text.
        if (!collapsing) {
          requestAnimationFrame(() => this.scrollToRevealedContent());
        }

        if (collapsing && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start' });
        }
      };
      this.button.addEventListener('click', this.onToggle);
      // Observe the full content, so measurement also works while collapsed.
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.content);
      this.update();
    }

    update() {
      const contentTop = this.content.getBoundingClientRect().top;
      const firstHeading = this.content.querySelector('h3');
      const fallback = parseFloat(getComputedStyle(this).getPropertyValue('--description-fallback-height')) || 680;
      const headingSplit = firstHeading ? firstHeading.getBoundingClientRect().top - contentTop : 0;
      const limit = headingSplit > 1 ? Math.round(headingSplit) : fallback;

      this.revealTarget = headingSplit > 1 ? firstHeading : null;
      this.collapsedHeight = limit;
      this.style.setProperty('--description-collapsed-height', `${limit}px`);
      const overflowing = this.content.getBoundingClientRect().height > limit + 1;
      if (!overflowing) this.expanded = false;
      this.button.hidden = !overflowing;
      this.toggleAttribute('data-collapsed', overflowing && !this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.textContent = this.expanded ? this.button.dataset.showLess : this.button.dataset.showMore;
    }

    scrollToRevealedContent() {
      const rootStyles = getComputedStyle(document.documentElement);
      const stickyHeaderHeight = parseFloat(rootStyles.getPropertyValue('--sticky-header-height'));
      const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height'));
      const offset = (stickyHeaderHeight || headerHeight || 0) + 16;
      const revealTop = this.revealTarget
        ? this.revealTarget.getBoundingClientRect().top + window.scrollY
        : this.content.getBoundingClientRect().top + window.scrollY + this.collapsedHeight;

      window.scrollTo({
        top: Math.max(0, revealTop - offset),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
    }
  });
}
